import {FormattedMessage, defineMessages} from 'react-intl';
import {Badge} from 'src/v2/components/common/Badge';
import {Text} from 'src/v2/components/common/Text';
import {useSelector} from 'src/v2/state/store';

const messages = defineMessages({
  noGasFees: {
    id: 'crypto.payins.v2.gasless_badge.no_gas_fees',
    description: 'Badge indicating no gas fees for gasless payments',
    defaultMessage: 'No gas fees',
  },
  noGasFeesForNonSmartWallets: {
    id: 'crypto.payins.v2.gasless_badge.no_gas_fees_for_non_smart_wallets',
    description:
      'Badge indicating no gas fees for gasless payments, with a note that smart wallets are excluded',
    defaultMessage: 'No gas fees for non-smart wallets',
  },
});

export const GaslessBadge = ({walletProvider}: {walletProvider?: string}) => {
  const enableSmartContractWalletDetection = useSelector(
    (state) => state.featureFlags.enable_smart_contract_wallet_detection,
  );

  const showSmartWalletDisclaimer =
    walletProvider === 'Coinbase Wallet' && enableSmartContractWalletDetection;

  return (
    <Badge type="positive">
      <Text type="caption" css={{color: 'inherit'}}>
        <FormattedMessage
          {...(showSmartWalletDisclaimer
            ? messages.noGasFeesForNonSmartWallets
            : messages.noGasFees)}
        />
      </Text>
    </Badge>
  );
};
